// MSAL's acquireTokenSilent/ssoSilent load redirectUri in a hidden iframe to
// capture the auth response hash. Since redirectUri is the SPA root (no spare
// blank.html route), that iframe boots the full app. If the app then runs its
// own MSAL init/handleRedirectPromise/login calls, MSAL detects a nested auth
// response and throws block_iframe_reload. Detecting this frame lets us skip
// that boot work entirely, per Microsoft's block_iframe_reload guidance:
// https://learn.microsoft.com/en-us/entra/identity-platform/msal-error-handling-js#block_iframe_reload
export const isMsalAuthFrame = (
  isFramed: boolean = window.parent !== window,
  hash: string = window.location.hash
): boolean => {
  if (!isFramed) return false;
  return /[#&](code|error)=/.test(hash);
};
